import React from 'react';

const Icon = ({ className, imgSrc, width, height, alt = '' }) => {
  return <img className={className} src={imgSrc} width={width} height={height} alt={alt} />;
};

export default Icon;
